/**
 * @file: 货架拖拽
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import Utils from '../../../utils/util';
import CodiSystem from '../../../codiSystem/index';
import History from '../../history/index';
import Update from '../../../update/index';
import InsertArrow from './arrow';
import Move from '../../move/index';
import DragRunerBase from '../dragRunerBae/index';
import { makeMoveTask } from './move';

class FreezerDragRuner extends DragRunerBase {
    private arrow: ShelfInsertArrow;
    private targetLayerChild: CubeId|null;
    private shelfsCoordinate: CubePaintCoordinate[];
    private topStart: number;
    private leftStart: number;
    private dragCubes: CubeId[];
    private dragLayerCubes: CubeId[];
    private dragShelfCubes: CubeId[];
    private moveTaskQueue: MoveTask;
    private dragCube: CubeId;

    constructor() {
        super();
        this.arrow = new InsertArrow();
        this.shelfsCoordinate = [];
        this.topStart = 0;
        this.leftStart = 0;
        this.dragCubes = [];
        this.dragLayerCubes = [];
        this.dragShelfCubes = [];
    }

    dragStart(transfer: Transfer, dragCube: CubeId): void {
        let $sketchpad: JQuery.Coordinates = $('.shelvesbuild-e-sketchpad').offset();
        let stageCanDropLayers: CubeId[] = CubeTree.findLayersCanDropInStage();

        this.dragLayerCubes = transfer.findDragLayerCubes();
        this.dragShelfCubes = transfer.findDragShelf();
        this.dragCubes = this.dragLayerCubes.concat(this.dragShelfCubes);
        this.shelfsCoordinate = CodiSystem.getPaintCoordinateByType('freezer');
        this.leftStart = $sketchpad.left;
        this.topStart = $sketchpad.top;
        this.dragCube = dragCube;
        this.hideDragNode();
    }

    drag(params: DragParams): void {
        let mousePoint: MousePoint = {
            left: Utils.math(params.ev.clientX, this.leftStart, '-'),
            top: Utils.math(params.ev.clientY, this.topStart, '-')
        };

        if (!this.dragShelfCubes.length) {
            return;
        }

        this.arrow.move({
            mousePoint,
            shelfsCoordinate: this.shelfsCoordinate,
            dragCubes: this.dragShelfCubes,
            transfer: params.transfer
        });
    }

    dragEnd(params: DragEndParams): void {
        if (!this.dragShelfCubes.length) {
            return;
        }

        // 构建移动任务队列
        this.moveTaskQueue = makeMoveTask(this.arrow, this.dragShelfCubes, params.transfer);

        /** 日志打印开始 **/
        Toolkit.log({
            action: '层板放置组件拖拽',
            msgList: [
                {
                    name: '逻辑移动任务队列',
                    value: this.moveTaskQueue.logic
                },
                {
                    name: '物理移动任务队列',
                    value: this.moveTaskQueue.physics
                }
            ]
        });
        /** 日志打印结束 **/

        History.stackIn({
            type: 'shelfDragMove',
            data: [Move.makeBackMoveTask(this.moveTaskQueue)]
        });
        Move.logic(this.moveTaskQueue.logic);
        this.shelfMoveUpdate();
        this.showDragNode();
        this.arrow.destroy();
    }

    private hideDragNode(): void {
        this.dragCubes.forEach((cubeId: CubeId): void => {
            let cube: CubeNode = CubeTree.findByCubeId(cubeId);

            cube.jView.addClass('drag-hide');
        });
    }

    private showDragNode(): void {
        this.dragCubes.forEach((cubeId: CubeId): void => {
            let cube: CubeNode = CubeTree.findByCubeId(cubeId);

            cube.jView.removeClass('drag-hide');
        });
    }
}

export default FreezerDragRuner;
